export default __webpack_public_path__ + "static/media/2172.44844214.png";